import { useEffect } from 'react';
import styles from './TermsPage.module.css';
import { brandConfig } from '../../config/brands';
import { appPath } from '../../utils/navigation';

export default function TermsPage() {
  // OEMブランドで外部URLが設定されている場合はリダイレクト
  if (brandConfig.urls.terms) {
    useEffect(() => {
      window.location.href = brandConfig.urls.terms!;
    }, []);
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <header className={styles.header}>
          <a href={appPath('/')} className={styles.logoLink}>
            <img src={brandConfig.logoWhite} alt={brandConfig.serviceName} className={styles.logo} />
          </a>
        </header>

        <main className={styles.content}>
          <h1 className={styles.title}>利用規約</h1>
          <p className={styles.lastUpdated}>最終更新日: 2024年1月1日</p>

          <section className={styles.section}>
            <h2>第1条（適用）</h2>
            <p>
              本規約は、株式会社Light Media（以下「当社」といいます）が提供するサービス「{brandConfig.serviceName}」（以下「本サービス」といいます）の利用条件を定めるものです。登録ユーザーの皆さま（以下「ユーザー」といいます）には、本規約に従って本サービスをご利用いただきます。
            </p>
          </section>

          <section className={styles.section}>
            <h2>第2条（利用登録）</h2>
            <p>
              本サービスにおいては、登録希望者が本規約に同意の上、当社の定める方法によって利用登録を申請し、当社がこれを承認することによって、利用登録が完了するものとします。
            </p>
            <p>
              当社は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
            </p>
            <ul>
              <li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
              <li>本規約に違反したことがある者からの申請である場合</li>
              <li>その他、当社が利用登録を相当でないと判断した場合</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>第3条（ユーザーIDおよびパスワードの管理）</h2>
            <p>
              ユーザーは、自己の責任において、本サービスのユーザーIDおよびパスワードを適切に管理するものとします。
            </p>
            <p>
              ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。当社は、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。
            </p>
          </section>

          <section className={styles.section}>
            <h2>第4条（禁止事項）</h2>
            <p>ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
            <ul>
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>当社、本サービスの他のユーザー、または第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
              <li>当社のサービスの運営を妨害するおそれのある行為</li>
              <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
              <li>不正アクセスをし、またはこれを試みる行為</li>
              <li>他のユーザーに成りすます行為</li>
              <li>当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
              <li>その他、当社が不適切と判断する行為</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>第5条（本サービスの提供の停止等）</h2>
            <p>
              当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
            </p>
            <ul>
              <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
              <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
              <li>コンピュータまたは通信回線等が事故により停止した場合</li>
              <li>その他、当社が本サービスの提供が困難と判断した場合</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>第6条（著作権）</h2>
            <p>
              ユーザーは、自ら著作権等の必要な知的財産権を有するか、または必要な権利者の許諾を得た文章、画像や映像等の情報に関してのみ、本サービスを利用し、投稿ないしアップロードすることができるものとします。
            </p>
            <p>
              本サービスを利用して生成されたコンテンツの著作権は、当該コンテンツを生成したユーザーに帰属するものとします。ただし、当社は本サービスの改善・開発のため、生成されたコンテンツを匿名化した形で利用できるものとします。
            </p>
          </section>

          <section className={styles.section}>
            <h2>第7条（利用料金および支払方法）</h2>
            <p>
              ユーザーは、本サービスの有料部分の対価として、当社が別途定め、本ウェブサイトに表示する利用料金を、当社が指定する方法により支払うものとします。
            </p>
          </section>

          <section className={styles.section}>
            <h2>第8条（免責事項）</h2>
            <p>
              当社の債務不履行責任は、当社の故意または重過失によらない場合には免責されるものとします。
            </p>
            <p>
              当社は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
            </p>
          </section>

          <section className={styles.section}>
            <h2>第9条（サービス内容の変更等）</h2>
            <p>
              当社は、ユーザーへの事前の告知をもって、本サービスの内容を変更、追加または廃止することがあり、ユーザーはこれを承諾するものとします。
            </p>
          </section>

          <section className={styles.section}>
            <h2>第10条（利用規約の変更）</h2>
            <p>
              当社は以下の場合には、ユーザーの個別の同意を要せず、本規約を変更することができるものとします。
            </p>
            <ul>
              <li>本規約の変更がユーザーの一般の利益に適合するとき</li>
              <li>本規約の変更が本サービス利用契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>第11条（個人情報の取扱い）</h2>
            <p>
              当社は、本サービスの利用によって取得する個人情報については、当社「プライバシーポリシー」に従い適切に取り扱うものとします。
            </p>
          </section>

          <section className={styles.section}>
            <h2>第12条（準拠法・裁判管轄）</h2>
            <p>本規約の解釈にあたっては、日本法を準拠法とします。</p>
            <p>
              本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。
            </p>
          </section>
        </main>

        <footer className={styles.footer}>
          <p>© <a href={brandConfig.urls.website} target="_blank" rel="noopener noreferrer">{brandConfig.companyName}</a></p>
        </footer>
      </div>
    </div>
  );
}
